import React, { useState, useEffect, useMemo } from 'react';
import { MetricUId } from '../../Metrics/constants';
import { getMetricDataFromArray } from '../../Metrics/utils';
import SiloBustingFilterPane from './SiloBustingFilterPane';
import SiloBustingChart from './SiloBustingChart';
import i18n from '../../../../utils/ChrI18n';
import useSiloBustingDataFetcher from './useSiloBustingDataFetcher';
import ChrWidgetLoaders from '../../../generic/PageUI/Basic/Widget/ChrWidgetLoaders';
import { getInitialSelection } from './utils';

const allConnectionsOption = {
  id: null,
  value: 'all',
  favorite: false,
  description: null,
  label: i18n.t('widgets.silo_busting.all_connections', jsConstants.customTerms)
};

const Body = (props) => {
  const { metrics, url } = props;
  const controlData = getMetricDataFromArray(metrics, MetricUId.SILO_BUSTING_FILTER_PANE_DATA)?.data || {};

  const connectionViewOptions = controlData.connection_views || [];
  const profileQuestionOptions = controlData.profile_questions || [];
  const defaultConnectionViewId = controlData.default_connection_view_id;
  const defaultProfileQuestionId = controlData.default_profile_question_id;
  const groupsPath = controlData.groups_path;
  const canManageGroupViews = controlData.can_manage_group_views || false;

  const allConnectionViewOptions = [ allConnectionsOption, ...connectionViewOptions ];

  const [selectedConnectionView, setSelectedConnectionView] = useState(
    getInitialSelection(allConnectionViewOptions, defaultConnectionViewId)
  );

  const [selectedProfileQuestion, setSelectedProfileQuestion] = useState(
    getInitialSelection(profileQuestionOptions, defaultProfileQuestionId)
  );

  // Use custom hook for data fetching logic
  const { chartComponentData, isLoading } = useSiloBustingDataFetcher({
    selectedConnectionView,
    selectedProfileQuestion,
    url
  });

  const filterPaneProps = {
    selectedConnectionView,
    onConnectionViewChange: setSelectedConnectionView,
    selectedProfileQuestion,
    onProfileQuestionChange: setSelectedProfileQuestion,
    connectionViewOptions: allConnectionViewOptions,
    profileQuestionOptions,
    groupsPath,
    canManageGroupViews,
    isChartDataLoading: isLoading
  };

  return (
    <div className="p-4 d-flex flex-column flex-md-row flex-gap-24 cui_silo_busting_widget_body">
      <SiloBustingFilterPane {...filterPaneProps} />
      {isLoading ? (
        <div className="cui_silo_busting_chart flex-grow-2 b-r-8 p-20 cui-custom-bg-secondary d-flex justify-content-center align-items-center">
          <ChrWidgetLoaders rows={1} columns={2} containerClassName="flex-gap-24" additionalClassNames="m-0" />
        </div>
      ) : (
        <SiloBustingChart chartComponentData={chartComponentData} />
      )}
    </div>
  );
};

export default Body;
